import { ID, Task } from '@griply/types';

import { primaryGoalId, primaryLifeAreaId } from './links/task-link-ids';

export type LinkedItemLabelOwner = {
  goalId?: ID;
  lifeAreaId?: ID;
};

export type HiddenLinkedItemLabels = {
  hideGoal: boolean;
  hideLifeArea: boolean;
};

// Compares the link the row actually renders — its first one. Matching on the whole array
// would blank the chip of a task that is on this goal AND another, hiding that second link
// entirely instead of naming it.
export const getHiddenLinkedItemLabels = (
  task: Task,
  { goalId, lifeAreaId }: LinkedItemLabelOwner,
): HiddenLinkedItemLabels => ({
  hideGoal: !!goalId && primaryGoalId(task) === goalId,
  hideLifeArea: !!lifeAreaId && primaryLifeAreaId(task) === lifeAreaId,
});
